<template>
    <div>
        <v-btn class="ma-2 no-display" tile outlined color="warning" @click="print()">
            <v-icon left>mdi-printer</v-icon> Print <v-icon right></v-icon>
        </v-btn>
        <div id="document1" class="printdiv cbse" v-if="lc_data != null">
            <div>
                <img :src="lc_data.school_photo_by_section" width="1100px" height="150px" alt="photo">
            </div>
            <!-- <v-row>
                <v-col cols="12" sm="5" md="5">
                    <p>{{ org_basic_data.trust_name }}</p>
                    <p>{{ org_basic_data.school_name }}</p>
                    <span>{{ org_basic_data.address }},</span>
                    <span>Ph. No.: <br>{{ org_basic_data.phone }}</span>
                </v-col>
                <v-col cols="12" sm="2" md="2">
                    <img :src="org_basic_data.school_logo" alt="school_logo" height="80px" width="80px" />
                </v-col>
                <v-col cols="12" sm="5" md="5">
                    <p>{{ org_basic_data.trust_name }}</p>
                    <p>{{ org_basic_data.school_name }}</p>
                    <span>{{ org_basic_data.address }},</span>
                    <span>Ph. No.: <br>{{ org_basic_data.phone }}</span>
                </v-col>
            </v-row> -->
            <div class="dotted-line"></div>
            <v-row>
                <v-col cols="12" sm="7" md="7" class="pb-0">
                    <p>School Reg. No. / शाळा नोंदणी क्र. : {{ org_basic_data.school_no }}</p>
                    <br>
                    <p>SSC Code / एस. एस. सी. कोड : {{ lc_data.school_ssc_code }}</p>
                    <p>UDISE No. / युडायस नं.: {{ lc_data.udise_no }}</p>
                </v-col>
                <v-col cols="12" sm="5" md="5" class="pb-0">
                    <p>Medium / माध्यम : {{ lc_data.school_medium }} / {{ getMarathiValue('medium',
                        lc_data.school_medium)}}</p>
                    <p>E-mail / ई-मेल : {{ org_basic_data.email }}</p>
                    <br>
                    <p>L.C.No. / एल. सी. क्र. : {{ lc_data.certificate_no }}</p>
                    <p>Year / वर्ष : {{ current_ay }}</p>
                    <p>G. R. No. / जनरल रजिस्टर क्र. : {{ lc_data.gr_number }}</p>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12" sm="4" md="4" class="pt-0">
                    <v-simple-table class="small-table">
                        <tr>
                            <td style="width: 20%">Original Copy / मूळ प्रत: </td>
                            <td colspan="3"></td>
                        </tr>
                        <tr>
                            <td>Duplicate Copy / दुय्यम प्रत:</td>
                            <td class="text-center">1</td>
                            <td class="text-center">2</td>
                            <td class="text-center">3</td>
                        </tr>
                    </v-simple-table>
                </v-col>
                <v-col cols="12" sm="4" md="4" class="pt-0" align="center" style="place-content: end;">
                    <h2>शाळा सोडल्याचा दाखला</h2>
                    <h2>School Leaving Certificate</h2>
                </v-col>
                <v-col cols="12" sm="2" md="2"></v-col>
            </v-row>
            <v-simple-table class="data-table">
                <tr>
                    <td class="index-col">1.</td>
                    <td colspan="2">Saral ID / सरल क्रमांक</td>
                    <td>{{ lc_data.saral_id }}</td>
                    <td colspan="4">PEN No./पेन क्र.{{ lc_data.pen_no }}</td>
                </tr>
                <tr>
                    <td class="index-col">2.</td>
                    <td colspan="2">Aadhaar No. / आधार क्रमांक</td>
                    <td>{{ lc_data.aadhar_no }}</td>
                    <td colspan="4">Apaar ID/अपार क्र.{{ lc_data.apaar_id }}</td>
                </tr>
                <tr>
                    <td class="index-col">3.</td>
                    <td colspan="2">Student's Full Name / <br> विद्यार्थ्यांचे संपूर्ण नाव</td>
                    <td colspan="5">{{ lc_data.fullname }} <br> {{ lc_data.marathi_fullname }}</td>
                </tr>
                <tr>
                    <td class="index-col">4.</td>
                    <td colspan="2">Student's Mother Name / <br> विद्यार्थ्याच्या आईचे नाव</td>
                    <td colspan="5">{{ lc_data.mother_first_name }} / {{ lc_data.marathi_mother_first_name }}</td>
                </tr>
                <tr>
                    <td class="index-col">5.</td>
                    <td colspan="2">Nationality / राष्ट्रीयत्व</td>
                    <td>{{ lc_data.nationality }} / {{ lc_data.unicode_nationality }}</td>

                    <td class="index-col">6.</td>
                    <td colspan="2">Mother Tongue / मातृभाषा</td>
                    <td>{{ lc_data.mothertoungue }} / {{ lc_data.unicode_mother_tongue }}</td>
                </tr>
                <tr>
                    <td class="index-col">7.</td>
                    <td colspan="2">Religion / धर्म</td>
                    <td>{{ lc_data.religion }} / {{ lc_data.unicode_religion }}</td>
                    <td class="index-col">8.</td>
                    <td>Gender / लिंग</td>
                    <td colspan="2">{{ lc_data.gender }} / {{ getMarathiValue('gender', lc_data.gender) }}</td>
                </tr>
                <tr>
                    <td class="index-col">9.</td>
                    <td colspan="2">Caste / जात / Sub Caste / पोटजात</td>
                    <td colspan="6">{{ lc_data.caste }} / {{ lc_data.unicode_cast }} / {{ lc_data.subcaste }} / {{
                        lc_data.unicode_subcast }}</td>
                </tr>
                <tr>
                    <td class="index-col" rowspan="2">10.</td>
                    <td colspan="2" rowspan="2">Place of Birth / जन्म ठिकाण</td>

                    <td colspan="2">
                        Village / City : {{ lc_data.birth_place }} <br>
                        गाव / शहर : {{ lc_data.unicode_birth_place }}<br><br>

                        Taluka : {{ lc_data.birth_taluka }} <br>
                        तालुका : {{ lc_data.unicode_birth_taluka }}
                    </td>

                    <td colspan="4">
                        District : {{ lc_data.birth_district }} <br>
                        जिल्हा : {{ lc_data.unicode_birth_district }}<br>

                        State : {{ lc_data.birth_state }} <br>
                        राज्य : {{ lc_data.unicode_birth_state }}<br>

                        Country : {{ lc_data.birth_country_new }} <br>
                        देश : {{ lc_data.unicode_birth_country }}
                    </td>
                </tr>
                <tr></tr>
                <tr>
                    <td class="index-col" rowspan="2">11.</td>
                    <td rowspan="2">
                        Date of Birth / <br>
                        जन्मदिनांक
                    </td>
                    <td>
                        As per Gregorian Calendar / <br>
                        ईसवी सन प्रमाणे
                    </td>
                    <td>
                        {{ lc_data.dob_fig }}
                    </td>
                    <td colspan="4">
                        In words : {{ lc_data.dob_words }} <br>
                        अक्षरी : {{ lc_data.dob_in_words_marathi }}
                    </td>
                </tr>
                <tr>
                    <td>
                        As per Indian Solar Calendar <br>
                        / भारतीय सौर प्रमाणे जन्मदिनांक
                    </td>
                    <td colspan="5">
                        {{ lc_data.dob_indian }}
                    </td>
                </tr>
                <tr>
                    <td class="index-col">12.</td>
                    <td colspan="2">Previous School / यापूर्वीची शाळा</td>
                    <td colspan="5">{{ lc_data.last_school }} <br> {{ lc_data.unicode_previous_school_name }}</td>
                </tr>
                <tr>
                    <td class="index-col">13.</td>
                    <td colspan="2">Standard in which studying / <br> कोणत्या इयत्तेत शिकत होता / होती</td>
                    <td>STD - {{ lc_data.standard }} / {{ lc_data.standard_in_marathi }}</td>
                    <td colspan="2">Since when (No.)/ <br> कधी पासून (अक्षरी)</td>
                    <td colspan="2">{{ lc_data.physical_date }} <br> {{ lc_data.unicode_physical_date }}</td>
                </tr>
                <tr>
                    <td class="index-col">14.</td>
                    <td colspan="2">Date of Admission / प्रवेशाचा दिनांक</td>
                    <td>{{ lc_data.doa }}</td>
                    <td colspan="4"> Standard : {{ lc_data.admittedstandard }}<br> इयत्ता : {{
                        lc_data.admittedstandard_in_marathi }}</td>
                </tr>
                <tr>
                    <td class="index-col">15.</td>
                    <td colspan="2">Progress / विद्यार्थ्यांची या शाळेतील प्रगती</td>
                    <td colspan="5">{{ lc_data.progress }}</td>
                </tr>
                <tr>
                    <td class="index-col">16.</td>
                    <td colspan="2">Conduct / विद्यार्थ्यांची या शाळेतील वर्तणूक</td>
                    <td colspan="5">{{ lc_data.conduct }}</td>
                </tr>
                <tr>
                    <td class="index-col">17.</td>
                    <td colspan="2">Date of Leaving / शाळा सोडल्याचा दिनांक</td>
                    <td>In Figures / <br> अंकी : {{ lc_data.last_date_of_school }}</td>
                    <td colspan="4">In words: {{ lc_data.last_date_of_school_in_words }}<br> अक्षरी : {{
                        lc_data.last_date_of_school_in_marathi }}</td>
                </tr>
                <tr>
                    <td class="index-col">18.</td>
                    <td colspan="2">Reason of Leaving / शाळा सोडल्याचे कारण</td>
                    <td colspan="5">{{ lc_data.reason }}</td>
                </tr>
                <tr>
                    <td class="index-col">19.</td>
                    <td colspan="2">Remark / शेरा</td>
                    <td colspan="5">{{ lc_data.remark }}</td>
                </tr>
            </v-simple-table>
            <small>
                Note : No change in any entry to be made except by the authority issuing the leaving certificate and
                that infringement of this
                requirement is liable to incur the imposition of penalty. Certified that the above information is in
                accordance with the
                School General Register.
            </small>
            <br>
            <small>
                टीप : वरील माहिती शाळेच्या जनरल रजिस्टर मधील नोंदी प्रमाणे आहे. शाळा सोडल्याच्या दाखल्यामध्ये
                अनधिकृतरित्या बदल केल्यास संबंधितांवर कायदेशीर कारवाई करण्यात येईल.
            </small>
            <v-row style="margin-top: 50px;">
                <v-col cols="4" class="text-left">
                    <div style="height: 45px;"></div>
                    <div>Date / दिनांक : {{ lc_data.date_of_issue }}</div>
                    <div>Place / ठिकाण :</div>
                </v-col>
                <v-col cols="4" class="text-center">
                    <div style="height: 45px;"></div>
                    <div>लेखनिक</div>
                    <div>
                        Clerk <br>
                        ({{ lc_data.clerk_name }}) <br>
                        ({{ lc_data.clerk_unicode_name }})
                    </div>
                </v-col>
                <v-col cols="4" class="text-center">
                    <div style="height: 45px;">
                        <img :src="awspath + lc_data.head_master_sign" height="45"/>
                    </div>
                    <div>मुख्याध्यापक</div>
                    <div>
                        Headmaster <br>
                        ({{ lc_data.head_master_name }}) <br>
                        ({{ lc_data.head_master_unicode_name }})
                    </div>
                </v-col>
            </v-row>
        </div>
    </div>
</template>
<script>
import axios from "axios";
import "@/assets/css/color.css"; // css needs to be imported for each dashboard
export default {
    data() {
        return {
            lc_data: null,
            org_basic_data: null,
            org_id: null,
            current_ay: null,
            awspath: null
        };
    },

    methods: {
        getMarathiValue(type, value) {
            const mappings = {
                nationality: {
                    "Indian": "भारतीय"
                },
                gender: {
                    "Male": "पुरुष",
                    "Female": "स्त्री"
                },
                medium: {
                    "English": "इंग्रजी",
                    "Marathi": "मराठी"
                },
                mothertongue: {
                    "Marathi": "मराठी",
                    "Hindi": "हिंदी",
                    "English": "इंग्रजी"
                }
            }

            if (
                mappings[type] &&
                mappings[type][value]
            ) {
                return mappings[type][value];
            }

            return value;
        },
        print() {
            this.$store.state.drawer = false;
            let that = this;
            window.onafterprint = function () {
                that.$store.state.drawer = true;
            };
            setTimeout(function () {
                window.print();
            }, 100);
        },
    },
    mounted() {
        this.lc_data = JSON.parse(localStorage.getItem("lc_data"));
        this.current_ay = localStorage.getItem("current_ay");
        this.org_basic_data = JSON.parse(localStorage.getItem("org_basic_data"));
        this.org_id = localStorage.getItem("EPS-org-id");
        this.awspath = localStorage.getItem("awspath");
    },
};
</script>
<style scoped>
.data-table td.index-col {
    width: 4%;
    white-space: nowrap;
    text-align: center;
}

.dotted-line {
    border-bottom: 2px dotted #000;
    width: 100%;
}

.small-table td {
    border: 1px solid black;
    padding-left: 10px;
    text-align: left;
}

.small-table {
    border: 1px solid black;
}

.small-table td:first-child {
    width: 50%;
}

.data-table td {
    border: 1px solid black;
    text-align: left;
}

.data-table {
    border: 1px solid black;
    text-align: left;
}

.printdiv {
    height: auto;
    margin-left: 10%;
    margin-right: 10%;
    padding: 10px;
    /* border: 1px solid black; */
    background-color: white;
    font-weight: 500;
}

p {
    margin: 0;
}

/* print lc css */
@media print {

    header,
    footer,
    nav,
    date {
        display: none !important;
    }

    .no-display,
    .v-input__control,
    input[type="button"],
    input[type="submit"],
    input[type="reset"],
    #v-card {
        display: none !important;
    }

    .printdiv {
        margin: 0;
        padding: 0;
    }

    @page {
        size: A4;
        margin: none;
        padding-top: 0;
        size: 11.5in 17.4in;
    }
}
</style>